import { render, staticRenderFns } from "./conversion-stats-card.vue?vue&type=template&id=4e48d082&scoped=true&"
import script from "./conversion-stats-card.vue?vue&type=script&lang=js&"
export * from "./conversion-stats-card.vue?vue&type=script&lang=js&"
import style0 from "./conversion-stats-card.vue?vue&type=style&index=0&id=4e48d082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e48d082",
  null
  
)

export default component.exports